
// 文件类型
export const FILE_TYPE = {
    COVER: 'cover', //封面
    IMAGE: 'image', //图片
    VIEDO: 'video', //视频
}